import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=436617fa&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=436617fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436617fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('436617fa')) {
      api.createRecord('436617fa', component.options)
    } else {
      api.reload('436617fa', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=436617fa&scoped=true&", function () {
      api.rerender('436617fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-22oaMpNuyLMP3/JS/comp/PopupBox.vue"
export default component.exports